import React, { Component } from "react";
import { Grid, Message } from "semantic-ui-react";
import LessonList from "../Lessons/LessonList";

class PreReqProgramList extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render(){
    return(
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Message
              floating
              size='tiny'
              header='Prerequisites for Joining'
              content='Although this may sound challenging, this will put you in the habit of working for the Quran daily, which is one of the essential keys to being successful! If you make it though these foundational lessons, then be CERTAIN that you have what it takes to stick to the yearly goals with EASE!'
              list={[
                'Before we memorize anything, there are some pre-requisites that must be completed.',
                'There are 29 lessons in total, these lessons will teach you the Quranic principles and foundations critical to your journey.'
              ]}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <LessonList />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
export default PreReqProgramList;